import { isHostOrSubdomain } from 'src/core/utils/Hosts';

const YOUTUBE_HOSTS = ['youtube.com', 'youtube-nocookie.com', 'youtu.be'];

const VIDEO_ID_PATTERNS = [/[?&]v=([^&#]+)/, /youtu\.be\/([^?&#/]+)/, /youtube\.com\/embed\/([^?&#/]+)/];

const isYoutubeHost = (url: string): boolean => {
	try {
		const { hostname } = new URL(url.trim());

		return isHostOrSubdomain(hostname, YOUTUBE_HOSTS);
	} catch {
		return false;
	}
};

export const youtubeVideoId = (url: string): string | null => {
	if (!isYoutubeHost(url)) {
		return null;
	}

	for (const pattern of VIDEO_ID_PATTERNS) {
		const match = pattern.exec(url);

		if (match?.[1]) {
			return match[1];
		}
	}

	return null;
};
